import { t } from '../../i18n';

export type ClientStatusVariant = 'active' | 'noProjects';

export interface ClientStatus {
    variant: ClientStatusVariant;
    color: string;
    bg: string;
}

// Returns the semantic status variant + its presentation colors.
// Translate the variant at render time via <FormattedMessage id={CLIENT_STATUS_I18N_KEY[variant]} />
// — translating inside this helper via t() doesn't re-run when messages load async,
// so cells would show stale language until the next re-render.
export const CLIENT_STATUS_I18N_KEY: Record<ClientStatusVariant, string> = {
    active: 'contact.status.active',
    noProjects: 'contact.status.noProjects',
};

export const getClientStatus = (client: any): ClientStatus => {
    if (!client) return { variant: 'noProjects', color: '#94a3b8', bg: '#f1f5f9' };

    const projectCount = client.projectCount ?? 0;

    if (projectCount > 0) {
        return { variant: 'active', color: '#22c55e', bg: '#dcfce7' };
    }
    return { variant: 'noProjects', color: '#94a3b8', bg: '#f1f5f9' };
};

export const getClientInitials = (client: any): string => {
    const first = client?.firstnameAndLastname || '';
    const last = client?.lastName || '';

    const f = first.trim().charAt(0).toUpperCase();
    const l = last.trim().charAt(0).toUpperCase();

    return (f + l) || '?';
};

export const getAvatarColor = (name: string): string => {
    const colors = [
        '#1e3a5f', '#2a5a8a', '#0d9488', '#7c3aed',
        '#db2777', '#ea580c', '#0891b2', '#4f46e5',
        '#059669', '#b91c1c', '#7e22ce', '#c2410c'
    ];
    let hash = 0;
    for (let i = 0; i < (name || '').length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
};

export const getProjectCount = (client: any): number => {
    return client?.projectCount ?? 0;
};

export const computeDashboardStats = (clients: any[], pagination: any) => {
    const total = pagination?.total ?? clients?.length ?? 0;

    // Unique cities from current page
    const cities = new Set((clients || []).map(c => c.city).filter(Boolean));

    return [
        { key: 'total',      label: t('contact.dashboard.totalClients'),    value: total,       icon: 'users' },
        { key: 'new',        label: t('contact.dashboard.newThisMonth'),    value: '\u2022',    icon: 'userPlus' },
        { key: 'projects',   label: t('contact.dashboard.activeProjects'),  value: '\u2022',    icon: 'folder' },
        { key: 'noMeasure',  label: t('contact.dashboard.noMeasure'),       value: '\u2022',    icon: 'alert' },
        { key: 'cities',     label: t('contact.dashboard.topCities'),       value: cities.size, icon: 'map' },
    ];
};

// createdAt comes from API as "dd-mm-yyyy" — just display as-is
export const formatDate = (dateStr: string): string => {
    if (!dateStr) return '\u2014';
    return dateStr;
};
